import { Poze } from "./poze.model";
import { Companie } from "./companie.model";
import { Product } from "./Product.model";

// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

export class Offer
{
  public id: string;
  public carId: string;
  public createdBy: string;
  public subject: string;
  public clientName: string;
  public status: string;
  public offerDetails: OfferDetail[];
  public offerPhotos: PhotoDetail[];
}

export class PhotoDetail {
  public id: string;
  public offerId: string;
  public photoId: string;
  public photo: string;
}

export class OfferDetail {
  public id: string;
  public offerId: string;
  public productId: string;
  public linkCatalog: string;
  public product: Product;
}

export class OfferVM {
  public id: string;
  public carId: string;

  public companieId: string;
  public companie: Companie;

  public createdBy: string;
  public status: string;
  public subject: string;
  public clientName: string;
  public offerDetails: OfferDetailVM[];
  public offerPhotos: PhotoDetailVM[];
}

export class PhotoDetailVM {
  public id: string;
  public offerId: string;
  public photoId: string;
  public photo: string;
}

export class OfferDetailVM {
  public id: string;
  public offerId: string;
  public productId: string;
  public linkCatalog: string;
}

